import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b10d3ae4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "process-info-card"
};
const _hoisted_3 = {
  class: "process-info-header"
};
const _hoisted_4 = {
  class: "process-info-top"
};
const _hoisted_5 = {
  class: "process-info-title"
};
const _hoisted_6 = {
  class: "process-info-tags"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tag-label"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tag-label"
}, "失败策略：", -1));
const _hoisted_9 = {
  key: 0,
  class: "process-info-desc"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "desc-label"
}, "流程描述：", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "back-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 12H5M12 19l-7-7 7-7"
})], -1));
const _hoisted_12 = {
  class: "table-container-wrapper"
};
const _hoisted_13 = {
  class: "table-top-flex"
};
const _hoisted_14 = {
  class: "table-title"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "流程明细列表", -1));
const _hoisted_16 = {
  class: "button-container"
};
const _hoisted_17 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Iconfont = _resolveComponent("Iconfont");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_commonDrawer = _resolveComponent("commonDrawer");
  const _directive_hasPermi = _resolveDirective("hasPermi");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.processInfo.processName), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
    class: _normalizeClass(["info-tag", _ctx.processInfo.processStatus == 1 ? 'tag-green' : 'tag-red'])
  }, [_hoisted_7, _createTextVNode(_toDisplayString(_ctx.processInfo.processStatus == 1 ? '启用' : '禁用'), 1)], 2), _createElementVNode("span", {
    class: _normalizeClass(["info-tag", _ctx.processInfo.failStrategy == 1 ? 'tag-blue' : 'tag-orange'])
  }, [_hoisted_8, _createTextVNode(_toDisplayString(_ctx.processInfo.failStrategy == 1 ? '继续执行' : '终止流程'), 1)], 2)])]), _ctx.processInfo.processDesc ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createTextVNode(_toDisplayString(_ctx.processInfo.processDesc), 1)])) : _createCommentVNode("", true)]), _createElementVNode("button", {
    class: "back-btn",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goBack())
  }, [_hoisted_11, _createTextVNode(" 返回 ")])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_Iconfont, {
    name: "zongzhuangjirongliang",
    class: "table-title-icon"
  }), _hoisted_15]), _createElementVNode("div", _hoisted_16, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    class: "addBtn",
    icon: _ctx.Plus,
    onClick: _ctx.handleAdd
  }, {
    default: _withCtx(() => [_createTextVNode("新增明细")]),
    _: 1
  }, 8, ["icon", "onClick"])), [[_directive_hasPermi, ['testProcess:page:add']]])])]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.detailList,
    border: "",
    stripe: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "index",
      label: "序号",
      width: "60",
      align: "center",
      fixed: "left"
    }), _createVNode(_component_el_table_column, {
      prop: "itemName",
      label: "测试项",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "stageNo",
      label: "阶段编号",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "testConfig.metric.field",
      label: "检测指标字段",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [_createTextVNode(_toDisplayString(row.itemId == 1 ? '气瓶压力' : row.testConfig?.metric?.field || '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "指标阈值1",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [_createTextVNode(_toDisplayString(row.itemId == 1 ? row.testConfig?.metric?.threshold ?? '-' : row.testConfig?.cycleCount ?? '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "指标阈值2",
      align: "center"
    }, {
      default: _withCtx(({
        row
      }) => [_createTextVNode(_toDisplayString(row.itemId == 1 ? row.testConfig?.metric?.targetPressure ?? '-' : row.testConfig?.repeatabilityThreshold ?? '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "createTime",
      label: "创建时间",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      label: "操作",
      width: "130",
      align: "center",
      fixed: "right"
    }, {
      default: _withCtx(({
        row
      }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        link: "",
        onClick: $event => _ctx.handleEdit(row)
      }, {
        default: _withCtx(() => [_createTextVNode("修改")]),
        _: 2
      }, 1032, ["onClick"])), [[_directive_hasPermi, ['testProcess:page:add']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "danger",
        link: "",
        onClick: $event => _ctx.handleDel(row)
      }, {
        default: _withCtx(() => [_createTextVNode("删除")]),
        _: 2
      }, 1032, ["onClick"])), [[_directive_hasPermi, ['testProcess:page:remove']]])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"])), [[_directive_loading, _ctx.tableLoading]])]), _createVNode(_component_commonDrawer, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _ctx.dialogVisible = $event),
    title: _ctx.title,
    "close-on-click-modal": false,
    onClose: _ctx.closeDialog,
    size: "600px"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.submitForm,
      loading: _ctx.saveLoading
    }, {
      default: _withCtx(() => [_createTextVNode("确 定")]),
      _: 1
    }, 8, ["onClick", "loading"]), _createVNode(_component_el_button, {
      onClick: _cache[8] || (_cache[8] = $event => _ctx.dialogVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取 消")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.formRules,
      "label-width": "120px",
      class: "detail-form"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "测试项",
        prop: "itemId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.form.itemId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.itemId = $event),
          placeholder: "请选择测试项",
          filterable: "",
          style: {
            "width": "100%"
          },
          disabled: !!_ctx.form.id
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testItemOptions, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.itemName,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "阶段编号",
        prop: "stageNo"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: _ctx.form.stageNo,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.form.stageNo = $event),
          min: 1,
          max: 100,
          "controls-position": "right",
          style: {
            "width": "100%"
          },
          placeholder: "同阶段并行执行，不同阶段串行"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _ctx.form.itemId == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_form_item, {
        label: "检测指标字段",
        prop: "field"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.field,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.form.field = $event),
          disabled: "",
          value: "气瓶压力"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "保压阈值",
        prop: "threshold"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: _ctx.form.threshold,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.form.threshold = $event),
          min: 0,
          precision: 2,
          "controls-position": "right",
          style: {
            "width": "100%"
          },
          placeholder: "请输入保压阈值"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "目标压力",
        prop: "targetPressure"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: _ctx.form.targetPressure,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.form.targetPressure = $event),
          min: 0,
          precision: 2,
          "controls-position": "right",
          style: {
            "width": "100%"
          },
          placeholder: "请输入目标压力"
        }, null, 8, ["modelValue"])]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _ctx.form.itemId == 5 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_form_item, {
        label: "循环次数",
        prop: "cycleCount"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: _ctx.form.cycleCount,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.form.cycleCount = $event),
          min: 1,
          max: 100,
          "controls-position": "right",
          style: {
            "width": "100%"
          },
          placeholder: "请输入循环次数"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "重复性阈值",
        prop: "repeatabilityThreshold"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: _ctx.form.repeatabilityThreshold,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.form.repeatabilityThreshold = $event),
          min: 0,
          precision: 2,
          "controls-position": "right",
          style: {
            "width": "100%"
          },
          placeholder: "请输入重复性阈值"
        }, null, 8, ["modelValue"])]),
        _: 1
      })], 64)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"])]);
}